import * as React from "react";

class ButtonKText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonK-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 214.06 82.51"
      >
        <g>
          <path
            fill="#fbf9ed"
            d="M70.6,49.38v2.14H50V49.38h8.81v-1.2H51.67v-2h7.15v-1h-6.4v-7.2h6.4v-.86H50.14V35h8.68V34c-2.18.09-4.41.16-6.45.18a7.35,7.35,0,0,0-.54-2.07A124.62,124.62,0,0,0,67.11,31L68.35,33c-2,.31-4.33.56-6.81.74V35h8.9v2.11h-8.9v.86h6.75v7.2H61.54v1h7.59v2H61.54v1.2ZM55.05,40.73h3.77v-1H55.05Zm3.77,2.64v-1H55.05v1Zm2.72-3.66v1h4v-1Zm4,2.64h-4v1h4Z"
          />
          <path
            fill="#fbf9ed"
            d="M80.82,40c-.16.31-.34.61-.52.93H90.93V52.22H88.2V51.4H80v.82H77.39V44.75a17.86,17.86,0,0,1-3.49,2.73,14.92,14.92,0,0,0-1.71-2.18A15.07,15.07,0,0,0,77.73,40H72.9V37.87h6c.16-.32.29-.66.43-1H74.49v-2H80c.09-.32.18-.63.25-1-1.89.06-3.77.09-5.54.06a7.12,7.12,0,0,0-.5-2A115.88,115.88,0,0,0,90.15,31L91.74,33a78.91,78.91,0,0,1-8.49.81c-.09.37-.2.73-.32,1.09h8.9v2H82.21c-.12.31-.25.65-.39,1H93.06V40Zm7.38,3H80v1H88.2Zm0,2.66H80v1H88.2Zm0,3.72v-1H80v1Z"
          />
          <path
            fill="#fbf9ed"
            d="M114.86,37.53A25,25,0,0,1,112,46.16a11.27,11.27,0,0,0,4.54,3.66,10,10,0,0,0-1.84,2.33,12.36,12.36,0,0,1-4.42-3.65,16.36,16.36,0,0,1-5.11,3.63,11.5,11.5,0,0,0-1.43-2.31H98.51v1.34H96v-10h3v-3.5h-4V35.1h4V31h2.71V35.1h3.72v2.52h-3.72v3.5h2.49c-.22-.18-.45-.34-.63-.46,2-2.2,3.27-5.83,3.88-9.71l2.77.43c-.23,1.23-.52,2.45-.86,3.61h6.92v2.54Zm-12.71,6.11H98.51v3.65h3.64Zm2.56,5.63a11.84,11.84,0,0,0,4.09-3.11,25.81,25.81,0,0,1-2-5.13,12.78,12.78,0,0,1-1,1.43c-.25-.23-.68-.61-1.14-1Zm3.86-11.74a25.12,25.12,0,0,0,1.86,6,20.69,20.69,0,0,0,1.73-6Z"
          />
          <path
            fill="#fbf9ed"
            d="M138.89,45.84h-2.37v3.95h-2.74v-.93h-4.09v.71c0,1.34-.32,1.88-1.2,2.27a12,12,0,0,1-4,.38,8.59,8.59,0,0,0-.89-2.13c1.09,0,2.43,0,2.79,0s.57-.16.57-.56v-.71H120v-2h6.9V45.84h-9V43.78h9v-1h-6.72V41h6.72V40h-6.15V35.49h6.15v-.93h-8.47V32.42h8.47V31h2.75v1.47h8.67v2.14h-8.67v.93h6.45V40h-6.45v1h6.83v2.8h2.37Zm-11.95-7.56V37.19h-3.56v1.09Zm2.75-1.09v1.09h3.68V37.19Zm0,6.59h4.09v-1h-4.09Zm4.09,2.06h-4.09v1.07h4.09Z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonKText;



// WEBPACK FOOTER //
// ./src/ending/components/ButtonKText.tsx